import { render, staticRenderFns } from "./SmartTable.vue?vue&type=template&id=fa678b0c"
import script from "./SmartTable.vue?vue&type=script&lang=js"
export * from "./SmartTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports